import { render } from "./operation-cover.vue?vue&type=template&id=ed5d9f4e&scoped=true&ts=true"
import script from "./operation-cover.vue?vue&type=script&setup=true&lang=ts"
export * from "./operation-cover.vue?vue&type=script&setup=true&lang=ts"

import "./operation-cover.vue?vue&type=style&index=0&id=ed5d9f4e&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5d9f4e"],['__file',"src/views/browse-view/components/operation-cover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed5d9f4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed5d9f4e', __exports__)) {
    console.log('reload')
    api.reload('ed5d9f4e', __exports__)
  }
  
  module.hot.accept("./operation-cover.vue?vue&type=template&id=ed5d9f4e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('ed5d9f4e', render)
  })

}


export default __exports__